import { render, staticRenderFns } from "./ComposantListeContenuPack.vue?vue&type=template&id=37988bb2&scoped=true"
import script from "./ComposantListeContenuPack.vue?vue&type=script&lang=js"
export * from "./ComposantListeContenuPack.vue?vue&type=script&lang=js"
import style0 from "./ComposantListeContenuPack.vue?vue&type=style&index=0&id=37988bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37988bb2",
  null
  
)

export default component.exports